import request from '@/utils/request'

// NotYet Warehousing
export function epms5040List(param) {
    let data = param
    return request({
        url: `/delivery/epms5040/epms5040List`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}